<div *ngIf="isLogoLoading$ | async" style="position: fixed; top: 0; left: 0; right: 0; bottom: 0; background-color: rgba(255, 255, 255, 1); display: flex; align-items: center; justify-content: center; z-index: 9999;">
  <div class="text-center">
    <p-progressBar mode="indeterminate" [style]="{ height: '8px', width: '250px' }"></p-progressBar>
    <p class="mt-3" style="color: var(--text-color); font-weight: 500">Loading...</p>
  </div>
</div><p-toast></p-toast> <router-outlet></router-outlet>
